import React, { useState } from "react";

const MwInputText = (props) => {
  const {
    id,
    value,
    defaultValue = "",
    onChange,
    readOnly,
    disabled,
    label,
    invalid,
    invalidMsg,
    placeholder,
    size,
    onKeyDown,
    classNameInput,
    containerClassName,
    inputRef,
    onInput,
    inputType = "text",
    dir = "auto",
  } = props;

  const [internalValue, setInternalValue] = useState(defaultValue);

  const handleChange = (e) => {
    if (onChange) {
      onChange(e);
    } else {
      setInternalValue(e.target.value);
    }
  };

  return (
    <div className={`relative mt-2 w-full ${containerClassName || ""}`}>
      {label && (
        <label className="text-xs font-[700] px-1 text-[#261759] pb-1 block" htmlFor={id}>
          {label}
        </label>
      )}

      <div className="relative  w-full">
        <input
          ref={inputRef}
          onInput={onInput}
          type={inputType}
          className={`h-9  flex flex-row-reverse text-xs mt-0 border-[#8D82B6] rounded-md border-opacity-55 text-[#463977] py-2 w-full border px-2 font-[700] outline-none ${
            size === "sm" ? "h-6" : "h-8"
          } ${invalid ? "border-red-500" : ""} ${
            disabled ? "bg-gray-100 cursor-not-allowed" : ""
          } ${classNameInput} ${
            inputType === "date" ? "date-input" : ""
          }`}
          name={id}
          value={value !== undefined ? value : internalValue}
          onChange={handleChange}
          onKeyDown={onKeyDown}
          readOnly={readOnly}
          disabled={disabled}
          placeholder={placeholder}
          dir={ inputType==="date" ?  "ltr": ""}
        />
        
        {inputType === "date" && (
          <div className={`absolute inset-y-0  flex items-center ${
            dir === "rtl" ? "right-3" : "left-3"
          } pointer-events-none`}>
            <img
              className="w-3 h-3"
              src="/assets/icons/date.png"
              alt="calendar"
            />
          </div>
        )}
      </div>

      {invalidMsg && <div className="text-xs text-red-500">{invalidMsg}</div>}
    </div>
  );
};

export default MwInputText;
